var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.6,
    height: 15.448,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 217",
    d: "M13.929.921a2.292 2.292 0 00-3.242 0l-9.088 9.088a.509.509 0 00-.131.224l-1.2 4.314a.509.509 0 00.627.627l4.314-1.2a.509.509 0 00.224-.131l9.087-9.088a2.3 2.3 0 000-3.242zM2.709 10.34l7.438-7.438 2.4 2.4-7.438 7.438zm-.479.961l1.916 1.917-2.651.734zM13.806 4.04l-.54.54-2.4-2.4.54-.54a1.273 1.273 0 011.8 0l.6.6a1.275 1.275 0 010 1.8zm0 0",
    fill: "#5200f1",
    stroke: "#5200f1",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c5ea84fb8fee26c047999d06e1cacae1.svg";
export { ForwardRef as ReactComponent };